import React from 'react';
import cn from 'classnames';
import styles from './style.module.css';

const Row = ({
  children,
  between = false,
  center = false,
  start = false,
  around = false,
  evenly = false,
  ...props
}) => {
  return (
    <div
      className={cn([
        styles.row,
        between && styles.between,
        center && styles.center,
        start && styles.start,
        around && styles.around,
        evenly && styles.evenly,
      ])}
      {...props}
    >
      {children}
    </div>
  );
};

export default Row;
